import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import { X, Check } from 'lucide-react';
import L from 'leaflet';

// Configurar ícones do Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.8.0/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.8.0/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.8.0/images/marker-shadow.png',
});

function MapClickHandler({ onMapClick }) {
  useMapEvents({
    click: (e) => {
      onMapClick([e.latlng.lat, e.latlng.lng]);
    },
  });
  return null;
}

const SeletorMapa = ({ onPontoSelecionado, onFechar, titulo }) => {
  const [pontoSelecionado, setPontoSelecionado] = useState(null);
  
  // Coordenadas de Conceição do Castelo - ES
  const centroConceicaoCastelo = [-20.359292, -41.247282];

  const handleMapClick = (coordenadas) => {
    setPontoSelecionado(coordenadas);
  };

  const confirmarSelecao = () => {
    if (pontoSelecionado) {
      onPontoSelecionado(pontoSelecionado);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal" style={{ maxWidth: '800px', width: '95%', height: '80vh' }}>
        <div className="modal-header">
          <h3 className="modal-title">{titulo}</h3>
          <button className="close-button" onClick={onFechar}>
            <X size={20} />
          </button>
        </div>

        <div style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
          <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
            Clique no mapa para selecionar o ponto desejado.
            {pontoSelecionado && (
              <span style={{ color: '#28a745', fontWeight: 'bold' }}>
                {' '}Ponto selecionado: {pontoSelecionado[0].toFixed(6)}, {pontoSelecionado[1].toFixed(6)}
              </span>
            )}
          </p>
        </div>

        <div style={{ height: 'calc(100% - 120px)', marginBottom: '15px' }}>
          <MapContainer
            center={centroConceicaoCastelo}
            zoom={14}
            style={{ height: '100%', width: '100%', borderRadius: '8px' }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <MapClickHandler onMapClick={handleMapClick} />
            {pontoSelecionado && (
              <Marker position={pontoSelecionado} />
            )}
          </MapContainer>
        </div>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button className="button secondary" onClick={onFechar}>
            Cancelar
          </button>
          <button 
            className="button" 
            onClick={confirmarSelecao}
            disabled={!pontoSelecionado}
          >
            <Check size={16} />
            Confirmar Seleção
          </button>
        </div>
      </div>
    </div>
  );
};

export default SeletorMapa;